const initialState = {
    isOpen: false,
    isActive: false,
};
const modalEditMobileWarning = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_EDIT_MOBILE_WARNING':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalEditMobileWarning;
